// @flow
import { compose } from 'react-recompose';
import { withNavigationFocus } from '@react-navigation/compat';
import { connect } from 'react-redux';
import PassportCheck from './PassportCheck';
import { clearPersonalInfo, storePassportInfo } from '../../../modules/Customer';
import type { MrzResult } from './lib';
import formatMrzResults from '../../../lib/MrzResultsFormatter';

const mapDispatchToProps = dispatch => ({
  clearPersonalInfo: () => dispatch(clearPersonalInfo()),
  storePassportInfo: (results: MrzResult | null, image: string) =>
    dispatch(storePassportInfo(formatMrzResults(results, image))),
});

export default compose(withNavigationFocus, connect(null, mapDispatchToProps))(PassportCheck);
